import { createFileRoute } from "@tanstack/react-router";
import { EventForm } from "@/components/EventForm";

export const Route = createFileRoute("/_authenticated/events_/$eventId/edit")({
  component: EditEventPage,
  head: () => ({
    meta: [
      { title: "Редактировать мероприятие — Turkey Drive" },
      {
        name: "description",
        content: "Обнови детали своего мероприятия в сообществе Turkey Drive.",
      },
      { property: "og:title", content: "Редактировать мероприятие — Turkey Drive" },
      {
        property: "og:description",
        content: "Обнови дату, место, стоимость и соорганизатора своего события.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
});

function EditEventPage() {
  const { eventId } = Route.useParams();
  return <EventForm eventId={eventId} />;
}
